//----------------------------------------------------
// Quantity Generic functions
//----------------------------------------------------
// these are generic functions that can be used in any
// context.


/**
 * Toggles the visibility of a target element when the source element is clicked.
 *
 * @param {string} sourceId - The id of the source element.
 * @param {string} targetId - The id of the target element.
 *
 * Assumes the target has a class "hidden" with "display: none"
 */
function toggleHidden(sourceId, targetId) {
	console.log("-----------------------------------------")
	console.log(sourceId);
	console.log(targetId);
	console.log("-----------------------------------------")
	document.getElementById(sourceId).addEventListener("click", (evt) => {
		document.getElementById(targetId).classList.toggle("hidden")
	});
}

/**
 *
 * @param tag - input tag
 * @param decrementBtn - button to disable when value is 1
 * @returns {boolean} - returns true if value the quantity was updated
 */
function decrementQty(tag, decrementBtn = null) {
	// don't rely on js conversion from string to number
	let value = +tag.value;
	if (value < 2) {
		if (decrementBtn) {
			decrementBtn.disabled = true
		}
		return false;
	}
	value -= 1;
	if (decrementBtn) {
		decrementBtn.disabled = value < 2
	}
	tag.value = value.toString();

	return true
}

/**
 * Function to increment the value of the input tag
 * @param tag - input tag
 * @param decrementBtn - button to enable when value is greater than 1
 * @returns {boolean} - returns true if value the quantity was updated
 */
function incrementQty(tag, decrementBtn = null) {
	// don't rely on js conversion from string to number
	let value = +tag.value;
	const max = +tag.max || 100
	if (value >= max) {
		return false
	}
	value += 1;
	if (decrementBtn) {
		decrementBtn.disabled = value < 2
	}
	tag.value = value.toString();
	return true
}

/**
 * _.defaultTo from lodash
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
 *
 * @param {*} value - Value to check
 * @param {*} defaultValue - Default value
 * @returns {*} - Returns the resolved value
 */
function defaultTo(value, defaultValue) {
	return value == null || value !== value ? defaultValue : value;
}

// TODO: clean this
const utilityFunctions = {
	/* Takes an amount in cents and returns it as a formatted dollar value. */
	formatMoney: function (cents, format, language) {
		if (typeof cents === "string") {
			cents = cents.replace(".", "");
			cents = cents.replace(",", "");
		}
		let value = "";
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultTo(precision, 2);
			thousands = defaultTo(thousands, " ");
			decimal = defaultTo(decimal, ".");

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			const parts = number.split(".");
			const dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				"$1" + thousands
			);
			const centsAmount =
				parts[1] && parts[1] !== "00" ? decimal + parts[1] : "";

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case "amount":
				value = formatWithDelimiters(cents, 2);
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0);
				break;
			case "amount_with_space_separator":
				value = formatWithDelimiters(cents, 2, " ", ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ",", ".");
				break;
			case "amount_no_decimals_with_space_separator":
				// Show decimals only if there are non-zero cents
				var precision = cents % 100 === 0 ? 0 : 2;
				value = formatWithDelimiters(cents, precision, " ", ",");
				break;
		}

		// var formattedValue = formatString.replace(placeholderRegex, value);
		// Adjust the currency symbol position based on language
		// return formattedValue;
		return formatString.replace(placeholderRegex, value);

		/* Use this code if we need to manually position the currency symbol */
		/* if (language === 'fr') {
		 return formattedValue + ' $';
		 } else {
		 return '$' + formattedValue;
		 }*/
	},
};

